import { DollarAmount } from '@strata/react-dollar-amount';
import { FormSection } from '@strata/react-form-section';
import classNames from 'classnames';

import { PerformanceComponent } from 'components/wonReferrals/PerformanceComponent';
import { ReferralValueCase } from 'store/api/performanceApi';

interface PerformanceProps {
    selectedReferral?: {
        incentiveTotal?: number;
        valueCases: ReferralValueCase[];
    };
}

export const Performance = ({ selectedReferral = undefined }: PerformanceProps) => (
    <FormSection
        sectionTitle="Performance"
        content={
            <div>
                {(selectedReferral?.incentiveTotal ?? 0) > 0 && (
                    <div className="flex__gap--x-small padding__top--small padding__bottom--large">
                        <DollarAmount amount={selectedReferral!.incentiveTotal} hideCents large />
                        <div className="font-semi-bold--capitalize--italic">Available</div>
                    </div>
                )}
                {selectedReferral?.valueCases?.map((a, index) => (
                    <div
                        className={classNames({
                            'padding__bottom--medium':
                                index < selectedReferral.valueCases.length - 1,
                        })}
                        key={a.value_case_id}
                    >
                        <PerformanceComponent performanceRequirement={a} />
                    </div>
                ))}
            </div>
        }
    />
);
